<template>
  <button
    class="square-icon-button"
    :style="{
      '--bg-color': bgColor,
      '--hover-color': hoverColor,
      '--hover-icon-color': hoverIconColor,
    }"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="$emit('onClick')"
  >
    <SquareIcon :icon="icon" :white="white" :black="black" />
  </button>
</template>

<script setup>
import { computed } from "vue";

import SquareIcon from "./SquareIcon.vue";

const props = defineProps({
  ariaLabel: String,
  icon: Object,
  white: Boolean,
  black: Boolean,
  graph: Boolean,
  disabled: Boolean,
});

const bgColor = computed(() => {
  return props.graph
    ? `var(--white-100)`
    : props.white || props.black
    ? "transparent"
    : `var(--primary-yellow)`;
});

const hoverColor = computed(() => {
  return props.white || props.black
    ? `transparent`
    : `var(--primary-yellow-light)`;
});

const hoverIconColor = computed(() => {
  return props.white ? `var(--white-100)` : `var(--black-100)`;
});
</script>

<style lang="scss" scoped>
.square-icon-button {
  background-color: var(--bg-color);
  border-radius: 2px;
  width: 1.5rem;
  aspect-ratio: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .square-icon {
    transition: background-color 0.3s;
  }
  

  &:hover:not(:disabled) {
    .square-icon {
      background-color: var(--hover-color);

      ::v-deep(.svg-icon path) {
        fill: var(--hover-icon-color);
      }
    }
  }

  &:disabled {
    opacity: 0.4;
  }
}
</style>
